import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  UtilityBasicForm,
  transformUtilitiesForSubmit,
  transformUtilitiesForForm,
} from 'accounts/components/form-fields/utilities';
import { StepFormLayout } from 'accounts/components/step-form-layout';
import { HOME_UTILITIES_STRINGS } from 'accounts/constants/strings/home-utilities.strings';
import { useSetupFlowStep } from 'accounts/hooks/homeowners/use-setup-flow-step-context';
import MultiStepFormSelector from 'components/v2/MultiStepFormSelector/MultiStepFormSelector';
import { isEmpty } from 'es-toolkit/compat';
import { updateStepData } from 'store/redux/home-listing-flow';

export function HomeUtilities() {
  // Holds the step's re-fetched payload; inferred from `null` it is `null` only.
  const [updatedData, setUpdatedData] = useState<any>(null);
  const {
    currentStep,
    currentStepFormData,
    handleSaveAndNext,
    goPreviousStep,
  } = useSetupFlowStep();
  const dispatch = useDispatch();

  const utilitiesProvider = currentStepFormData?.utilitiesProviders || [];

  const formProps = {
    hasHoa: !!currentStep?.property?.basicInfo?.hasHoa,
    utilitiesProvider,
  };
  const multiStepFormValues = updatedData?.utilitiesBilling?.utilities
    ? transformUtilitiesForForm(
        updatedData.utilitiesBilling.utilities,
        utilitiesProvider,
      )
    : getInitialValues();

  async function handleSubmit(values: any) {
    const transformedUtilities = transformUtilitiesForSubmit(values);
    const submitValues = {
      utilitiesBilling: {
        utilities: { ...transformedUtilities },
      },
    };

    handleSaveAndNext(submitValues);
  }

  function getInitialValues() {
    const sourceData = updatedData ?? currentStepFormData ?? {};
    const utilities = sourceData?.utilitiesBilling?.utilities || {};
    const transformedUtilities = transformUtilitiesForForm(
      utilities,
      utilitiesProvider,
    );
    const initialValues = { ...transformedUtilities };

    return initialValues;
  }

  async function handleSubmitEach(values: any) {
    const transformedUtilities = transformUtilitiesForSubmit(values);
    const submitValues = {
      utilitiesBilling: {
        utilities: { ...transformedUtilities },
      },
    };

    const updatedDataResponse = await dispatch(
      updateStepData(currentStep.flowId, currentStep, submitValues),
    );

    setUpdatedData(updatedDataResponse);
    return updatedDataResponse;
  }

  function customValidation(formValues: any) {
    const errorObject: Record<string, unknown> = {};

    Object.keys(formValues).forEach((key) => {
      if (isEmpty(formValues[key])) errorObject[key] = { error: 'error' };
    });

    return errorObject;
  }

  return (
    <StepFormLayout
      handleBackStep={goPreviousStep}
      onSubmit={handleSubmit}
      title={HOME_UTILITIES_STRINGS.title}
      initialValues={getInitialValues()}
      customValidation={customValidation}
      getForm={({ form }) => (
        <div className="mb-2xl md:mb-0">
          <MultiStepFormSelector
            values={multiStepFormValues}
            form={form}
            formComponent={UtilityBasicForm}
            formProps={formProps}
            showSkipButton={false}
            onSubmit={handleSubmitEach}
          />
        </div>
      )}
    />
  );
}
